var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option_button"},[_c('input',{attrs:{"id":_vm._uid,"name":_vm.group,"type":_vm.multiselect ? 'checkbox' : 'radio',"disabled":_vm.disable},domProps:{"checked":_vm.checked,"value":_vm.option},on:{"change":_vm.input}}),_c('label',{attrs:{"for":_vm._uid}},[_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }